export const quizQuestions = [
  {
    id: 1,
    question: "What is the correct command to create a new React project?",
    answers: [
      {
        id: 1,
        ans: "npx create-react-app",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "npx create-react-app appName",
        isCorrect: true,
      },
      {
        id: 3,
        ans: "npm create-react-app",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "npx create react-app",
        isCorrect: false,
      },
    ],
  },
  {
    id: 2,
    question: "What is the default port number in which the application run ?",
    answers: [
      {
        id: 1,
        ans: "3000",
        isCorrect: true,
      },
      {
        id: 2,
        ans: "8080",
        isCorrect: false,
      },
      {
        id: 3,
        ans: "4200",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "4000",
        isCorrect: false,
      },
    ],
  },
  {
    id: 3,
    question: "Which of the following is true regarding Babel ?",
    answers: [
      {
        id: 1,
        ans: "Compiler",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "Transpiler",
        isCorrect: false,
      },
      {
        id: 3,
        ans: "Both a and b",
        isCorrect: true,
      },
      {
        id: 4,
        ans: "None of the above",
        isCorrect: false,
      },
    ],
  },
  {
    id: 4,
    question: "Which of the following is true about key props ?",
    answers: [
      {
        id: 1,
        ans: "Key props are used to look beauty",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "Key prop is a way to identify the newly added element",
        isCorrect: true,
      },
      {
        id: 3,
        ans: "It is one type of attribute of HTML",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "It is not used in the array",
        isCorrect: false,
      },
    ],
  },
  {
    id: 5,
    question: "Reactjs is written in",
    answers: [
      {
        id: 1,
        ans: "Swift",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "Javascript",
        isCorrect: true,
      },
      {
        id: 3,
        ans: "AJAX",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "None",
        isCorrect: false,
      },
    ],
  },
  {
    id: 6,
    question: "React.js Covers only the view layer of the app.",
    answers: [
      {
        id: 1,
        ans: "Yes",
        isCorrect: true,
      },
      {
        id: 2,
        ans: "No",
        isCorrect: false,
      },
    ],
  },
  {
    id: 7,
    question: "What is the smallest building block of ReactJS?",
    answers: [
      {
        id: 1,
        ans: "Props",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "Elements",
        isCorrect: false,
      },
      {
        id: 3,
        ans: "Components",
        isCorrect: true,
      },
      {
        id: 4,
        ans: "None of the above",
        isCorrect: false,
      },
    ],
  },
  {
    id: 8,
    question:
      "How many numbers of elements a valid react component can return?",
    answers: [
      {
        id: 1,
        ans: "2",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "5",
        isCorrect: false,
      },
      {
        id: 3,
        ans: "4",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "1",
        isCorrect: true,
      },
    ],
  },
  {
    id: 9,
    question:
      "Which of the following function is called to render HTML to the web page in React?",
    answers: [
      {
        id: 1,
        ans: "ReactDOM.render()",
        isCorrect: true,
      },
      {
        id: 2,
        ans: "render()",
        isCorrect: false,
      },
      {
        id: 3,
        ans: "ReactDOM()",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "renderDOM()",
        isCorrect: false,
      },
    ],
  },
  {
    id: 10,
    question:
      "Identify the one which is used to pass data to components from outside",
    answers: [
      {
        id: 1,
        ans: "Render with arguments",
        isCorrect: false,
      },
      {
        id: 2,
        ans: "setState",
        isCorrect: false,
      },
      {
        id: 3,
        ans: "propTypes",
        isCorrect: false,
      },
      {
        id: 4,
        ans: "props",
        isCorrect: true,
      },
    ],
  },
];
